<template>
    <div class="accounting-detail-data accounting-loan-drawdown-detail">
        <div class="detail-container">
            <div class="detail-section">
                <div class="accounting-detail-items" style="margin-top: 25px;">
                    <div class="item vertical">
                        <div class="label">摘要</div>
                        <div class="value xl b">{{ documentDetail.summary }} 動撥 <Money :v="documentDetail.amount" /> 元</div>
                    </div>
                </div>
                <div class="accounting-detail-items" style="margin-top: 25px;">
                    <div class="item">
                        <div class="label">動撥借款</div>
                        <div class="value">{{ documentDetail.summary }}</div>
                    </div>
                    <div class="item">
                        <div class="label">借款編號</div>
                        <div class="value">{{ documentDetail.systemNo }}</div>
                    </div>
                    <div class="item">
                        <div class="label">動撥日期</div>
                        <div class="value">{{ documentDetail.drawdownDate | dateFormater("YYYY-MM-dd") }}</div>
                    </div>
                    <div class="item">
                        <div class="label">動撥金額</div>
                        <div class="value xl"><Money :v="documentDetail.amount" /><span class="cny">TWD</span></div>
                    </div>
                    <div class="item">
                        <div class="label">備註</div>
                        <div class="value">{{ documentDetail.note || "--" }}</div>
                    </div>
                </div>
            </div>
            <!-- 存款帳戶收入 -->
            <div class="detail-section">
                <div class="section-title">存款帳戶收入</div>
                <div class="accounting-detail-items" style="margin-top: 25px;">
                    <div class="item">
                        <div class="label">存入帳戶</div>
                        <div class="value">{{ documentDetail.depositorBankName }}</div>
                    </div>
                    <div class="item">
                        <div class="label">存入日期</div>
                        <div class="value">{{ documentDetail.drawdownDate | dateFormater("YYYY-MM-dd") }}</div>
                    </div>
                    <div class="item">
                        <div class="label">存入金額</div>
                        <div class="value xl"><Money :v="documentDetail.amount" /><span class="cny">TWD</span></div>
                    </div>
                </div>
            </div>
            <!-- 費用支出 -->
            <div class="detail-section">
                <div class="section-title">費用支出</div>
                <table cellspacing="0" cellpadding="0" class="accounting-detail-table" style="margin-top: 25px">
                    <thead>
                        <tr>
                            <th>項目</th>
                            <th>付款時間</th>
                            <th>付款帳戶</th>
                            <th class="right">付款金額</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(s, index) in feeTable" :key="index">
                            <td>{{ s.itemName }}</td>
                            <td>{{ s.dat | dateFormater("YYYY-MM-dd") }}</td>
                            <td>{{ s.bnK_NAM }}</td>
                            <td class="right"><Money :v="s.amt" /></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <!-- 借款帳戶資訊 -->
            <div class="detail-section">
                <div class="section-title">借款帳戶資訊</div>
                <div class="accounting-detail-items" style="margin-top: 25px;">
                    <div class="item">
                        <div class="label">借款帳戶</div>
                        <div class="value">{{ documentDetail.loanBankName }}</div>
                    </div>
                    <div class="item">
                        <div class="label">動撥日期</div>
                        <div class="value">{{ documentDetail.drawdownDate | dateFormater("YYYY-MM-dd") }}</div>
                    </div>
                    <div class="item">
                        <div class="label">動撥金額</div>
                        <div class="value xl"><Money :v="documentDetail.amount" /><span class="cny">TWD</span></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        datas: {
            type: Object,
            default: () => {},
        },
    },
    components: { },
    data() {
        return {
        };
    },
    computed: {
        documentDetail() {
            return this.datas.detail || {};
        },
        feeTable() {
            return [
                {
                    itemName: '信保費',
                    dat: this.documentDetail.feE_CD_PAY_DAT,
                    amt: this.documentDetail.feE_CD_AMT,
                    bnK_NAM: this.documentDetail.feE_CD_BNK_NAM,
                },
                {
                    itemName: '信貸手續費',
                    dat: this.documentDetail.feE_HAND_PAY_DAT,
                    amt: this.documentDetail.feE_HAND_AMT,
                    bnK_NAM: this.documentDetail.feE_HAND_BNK_NAM,
                },
                {
                    itemName: '匯費',
                    dat: this.documentDetail.reM_FEE_PAY_DAT,
                    amt: this.documentDetail.reM_FEE_AMT,
                    bnK_NAM: this.documentDetail.reM_FEE_BNK_NAM,
                },
            ];
        },
    },
    methods: {
    },
};
</script>
